



































































































































































































































































































import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IInvoice, DocumentDirectionEnum, InvoiceTypeEnum } from "@/models/invoice.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { formatCurrency } from "@/lib/utility/currency-helper";
import InvoiceFormLinesTableRow from "./InvoiceFormLinesTableRow.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";
import RulesMixin from "@/mixins/RulesMixin.vue";
import InvoicePartyForm from "./InvoicePartyForm.vue";
import Tooltip from "../utility/tooltip.vue";

@Component({
  components: {
    InvoiceFormLinesTableRow,
    InvoicePartyForm,
    Tooltip
  },
  filters: {
    getFlagEmoji
  }
})
export default class InvoiceFormPreview extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;
  readonly InvoiceLine = InvoiceLine;
  readonly DocumentDirectionEnum = DocumentDirectionEnum;

  @Ref("sellerForm") sellerForm!: InvoicePartyForm;

  @Ref("buyerForm") buyerForm!: InvoicePartyForm;

  @Prop()
  value!: IInvoice;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop({ default: false })
  isValid!: boolean;

  validity = {
    seller: true,
    buyer: true,
    number: true,
    due: true,
    date: true,
    header: true,
    footer: true,
    tableRow: [] as boolean[]
  };

  get taxRates() {
    return this.value.taxRates;
  }

  get invoiceTypes() {
    return [InvoiceTypeEnum.COMMERCIAL, InvoiceTypeEnum.CREDIT_NOTE];
  }

  mounted() {
    this.validity.tableRow.splice(0);
    this.validity.tableRow.push(...new Array(this.value.lineItems.length).fill(true));
  }

  @Watch("validity", { deep: true })
  updateValidity() {
    const isValids = Object.values(this.validity);
    for (const isValid of isValids) {
      if (Array.isArray(isValid)) {
        const isValids = isValid;
        for (const isValid of isValids) {
          if (!isValid) {
            this.$emit("update:isValid", false);
            return;
          }
        }
      }
      if (!isValid) {
        this.$emit("update:isValid", false);
        return;
      }
    }
    this.$emit("update:isValid", true);
  }

  addInvoiceLine() {
    this.value.lineItems.push(new InvoiceLine());
    this.validity.tableRow.push(false);
  }

  removeInvoiceLine(index: number) {
    this.value.lineItems.splice(index, 1);
    this.validity.tableRow.splice(index, 1);
  }

  addNoteEntry(note = "") {
    if (!this.value.notes) {
      this.value.notes = [];
    }
    this.value.notes.push(note);
  }

  removeNoteEntry(index: number) {
    if (!this.value.notes) {
      return;
    }

    this.value.notes.splice(index, 1);
  }
}
